// extracted by mini-css-extract-plugin
export var actionIcon = "_o5-0";